module.exports = __webpack_public_path__ + "img/157.454e670e.jpg";